import { ChatRequest } from "build-ts/agent";
import { ChatResponse } from "build-ts/chat";
import showToast from "hooks/useCustomToast";

/**
 * Start a tiga chat.
 * 
 * @param {ChatRequest} request - The chat request.
 * @returns {Promise<ChatResponse[]>} The chat response.
 * @throws {Error} Throws an error if the request fails.
 */
export const runTigaChat = async (request : ChatRequest) : Promise<ChatResponse[]> => {
   try {
    const chatResponse = await fetch(process.env.REACT_APP_RUN_TIGA!, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
        },
        credentials: "include",
        body: JSON.stringify(ChatRequest.toJSON(request))
    });

    if (!chatResponse.ok) {
        showToast("Failed to run tiga", "", "error");
        return [];
    }
    const data = await chatResponse.json();
    return data?.map((item: any) => ChatResponse.fromJSON(item));
   } catch (error) {
    showToast("Error in running tiga", "", "error");
    return [];
   }
};